import AppHeader from '../AppHeader'
export default {
  name: 'will-must-admin',
  components: {
    AppHeader
  },
  created () {
    this.search()
  },
  data () {
    return {
      csvFileName: null,
      searchCallbackFlag: false,
      outCondition: 1
    }
  },
  computed: {
    willMusts () {
      return this.$store.getters.willMusts
    }
  },
  methods: {
    search: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
      }
      const data = {
        'shop_id': ''
      }
      this.$store.dispatch('WILL_MUST_GET', {data: data, callback: callback})
    },
    formatDateToYM: function (str) {
      const re = /([0-9]*)-([0-9]*)-([0-9]*)/
      const result = str.replace(re, '$1年$2月')
      return result
    },
    getCsvWillMust: function (data) {
      const params = {
        'out_condition': this.outCondition,
        'will_must_date': data['will_must_date']
      }
      this.$store.dispatch('WILL_MUST_CSV_DOWNLOAD', { data: params, callback: this.onGetCsv })
    },
    onGetCsv: function (data) {
      this.csvFileName = 'must_will.csv'

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      const mimeType = 'text/csv'
      let csv = '店舗名,社員ID,氏名,ふりがな,役職名,提出状態,提出年月日,MUST回答内容,WILL回答内容,自己評価,振り返り\n'
      const self = this
      data.forEach(function (obj) {
        if (obj.shop_name) {
          csv += self.enquoteForCSV(obj.shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_id) {
          csv += self.enquoteForCSV(obj.user_id) + ','
        } else {
          csv += ','
        }
        if (obj.user_name) {
          csv += self.enquoteForCSV(obj.user_name) + ' ' + self.enquoteForCSV(obj.user_firstname) + ','
        } else {
          csv += ','
        }
        if (obj.user_name_furigana) {
          csv += self.enquoteForCSV(obj.user_name_furigana) + ' ' + self.enquoteForCSV(obj.user_firstname_furigana) + ','
        } else {
          csv += ','
        }
        if (obj.user_type_name) {
          csv += self.enquoteForCSV(obj.user_type_name) + ','
        } else {
          csv += ','
        }
        if (obj.reflect_content) {
          csv += '1' + ','
        } else {
          csv += '0' + ','
        }
        if (obj.reflect_content) {
          csv += obj.updated_at.substr(0, 10) + ','
        } else {
          csv += ','
        }
        if (obj.must_content) {
          csv += self.enquoteForCSV(obj.must_content) + ','
        } else {
          csv += ','
        }
        if (obj.will_content) {
          csv += self.enquoteForCSV(obj.will_content) + ','
        } else {
          csv += ','
        }
        if (obj.evaluation) {
          csv += self.enquoteForCSV(obj.evaluation) + ','
        } else {
          csv += ','
        }
        if (obj.reflect_content) {
          csv += self.enquoteForCSV(obj.reflect_content)
        }
        csv += '\n'
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      const hiddenElement = document.createElement('a')
      hiddenElement.download = this.csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, this.csvFileName)
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    getComfirmed: function (date) {
      let today = new Date()
      let wmday = new Date(date)
      return today > wmday ? '締切後' : '受付中'
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { // ",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must-admin.js